import React from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { useSelector, useDispatch } from 'react-redux'
import MaskCep from '../util/SimpleMask/MaskCep'
import { getCEP } from '../serviceAPI/cep'

export default function EnderecoForm() {
    const dispatch = useDispatch();

    const endereco = useSelector(state => state.endereco)
    const cep = endereco.cep
    
    function maskCep(e) {
        let v = e.target.value
        v = MaskCep(v)
        setCep(v);
    }

    async function buscarCep() {
        if (cep.length === 9) {
            await getCEP(cep, dispatch)
        }
    }
    function setCep(e) {
        const cep = e
        dispatch({ type: 'SET_CEP', cep: cep })
    }
    function setNumero(e) {
        const numero = e.target.value
        dispatch({ type: 'SET_NUMERO', numero: numero })
    }
    function setComplemento(e) {
        const complemento = e.target.value
        dispatch({ type: 'SET_COMPLEMENTO', complemento: complemento })
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={6} sm={3}>
                <TextField
                    fullWidth
                    variant="outlined"
                    label="CEP"
                    name="cep"
                    id="cep"
                    onChange={(e) => maskCep(e)}
                    value={endereco.cep}
                    required
                    onBlur={buscarCep}
                />
            </Grid>
            <Grid item xs={6} sm={9}></Grid>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    variant="outlined"
                    label="Logradouro"
                    name="logradouro"
                    id="logradouro"
                    value={endereco.logradouro}
                    disabled
                />
            </Grid>
            <Grid item xs={3} sm={2}>
                <TextField
                    fullWidth
                    variant="outlined"
                    label="Nº"
                    name="numero"
                    id="numero"
                    onChange={(e) => setNumero(e)}
                    required
                    value={endereco.numero}
                />
            </Grid>
            <Grid item xs={9} sm={10}>
                <TextField
                    fullWidth
                    variant="outlined"
                    label="Complemento"
                    name="complemento"
                    id="complemento"
                    onChange={(e) => setComplemento(e)}
                    value={endereco.complemento}
                />
            </Grid>
            <Grid item xs={5}>
                <TextField
                    fullWidth
                    variant="outlined"
                    label="Bairro"
                    name="Bairro"
                    id="Bairo"
                    value={endereco.bairro}
                    disabled
                />
            </Grid>
            <Grid item xs={5}>
                <TextField
                    fullWidth
                    variant="outlined"
                    label="Localidade"
                    name="localidade"
                    id="localidade"
                    value={endereco.localidade}
                    disabled
                />
            </Grid>
            <Grid item xs={2}>
                <TextField
                    fullWidth
                    variant="outlined"
                    label="UF"
                    name="uf"
                    id="uf"
                    value={endereco.uf}
                    disabled
                />
            </Grid>
        </Grid>
    );
}